/** Resolve a downloadable file URL from assorted report API response shapes. */
export const extractReportDownloadUrl = (payload) => {
  if (!payload) return '';
  if (typeof payload === 'string') {
    const s = payload.trim();
    return s.startsWith('http') || s.startsWith('/') ? s : '';
  }

  const pickString = (v) => {
    if (!v) return '';
    if (typeof v === 'string') {
      const s = v.trim();
      return s.startsWith('http') || s.startsWith('/') ? s : '';
    }
    if (typeof v === 'object') {
      return (
        pickString(v.fileUrl)
        || pickString(v.objectUrl)
        || pickString(v.signedUrl)
        || pickString(v.url)
        || pickString(v.s3Url)
        || pickString(v.pdfUrl)
        || pickString(v.reportUrl)
      );
    }
    return '';
  };

  const roots = [payload, payload.data, payload.result, payload.report, payload.reportDetails].filter(Boolean);
  for (const root of roots) {
    const url = pickString(root);
    if (url) return url;
  }
  return '';
};

export const triggerReportDownload = (fileUrl, filename = 'report.pdf') => {
  if (!fileUrl) return;
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = filename;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const downloadReportFromBlob = (blob, filename = 'report.pdf') => {
  const url = URL.createObjectURL(blob);
  triggerReportDownload(url, filename);
  URL.revokeObjectURL(url);
};

const getFilenameFromDisposition = (disposition) => {
  if (!disposition) return '';
  const match = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(disposition);
  return match ? decodeURIComponent(match[1].replace(/"/g, '')) : '';
};

export const downloadReportFromResponse = async (response, defaultFilename = 'report.pdf') => {
  const contentType = response.headers.get('content-type') || '';
  const disposition = response.headers.get('content-disposition') || '';
  const filename = getFilenameFromDisposition(disposition) || defaultFilename;

  if (contentType.includes('application/pdf') || contentType.includes('octet-stream')) {
    const blob = await response.blob();
    downloadReportFromBlob(blob, filename);
    return true;
  }

  const data = await response.json().catch(() => null);
  const fileUrl = extractReportDownloadUrl(data);
  if (fileUrl) {
    triggerReportDownload(fileUrl, filename);
    return true;
  }
  return false;
};

export const getDprReportFilename = (reportType, formattedLogDate, shift) => {
  const datePart = formattedLogDate || 'report';
  const typeLabels = {
    flash: 'flash-report',
    pdf: 'welding-report',
    onepage: 'one-page-report',
  };
  const base = typeLabels[reportType] || 'dpr-report';
  const shiftPart = reportType === 'flash' && shift ? `-${shift}` : '';
  return `${base}-${datePart}${shiftPart}.pdf`;
};
